<template>
  <div class="appointment-box">
    <appointment-demand-form
      v-if="pageShow.form"
      :page-show-fn="pageShowFn"
    />
    <div
      v-if="pageShow.appointment"
      class="appointment-list"
    >
      <div class="list-title">
        {{ $t("appointment.listTitle") }}
      </div>
      <div class="list-tip">
        <p>{{ $t("appointment.listDesc1") }}</p>
        <p>{{ $t("appointment.listDesc2") }}</p>
        <p>{{ $t("appointment.listDesc3") }}</p>
      </div>
      <div
        class="list-table"
        v-if="this.pageCount > 0"
      >
        <mm-carousel
          :class="{
            'left-active': currentPage > 1,
            'right-active': currentPage < pageCount,
          }"
          arrow="always"
          :indicator="false"
          :loop-play="false"
          :autoplay="false"
          :height="`${carouselHeight}px`"
          @change="changeList"
        >
          <mm-carousel-item
            v-for="(item, pageIndex) of this.pageCount"
            :key="pageIndex"
          >
            <template>
              <div class="list-item">
                <ul class="list-index list-left">
                  <li
                    v-for="(timeItem, index) of timeRange"
                    :key="index"
                  >
                    <div class="time">
                      <div class="detail">
                        {{ timeItem.implementation_time }}
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="list-right">
                  <ul class="list-index list-header">
                    <li
                      v-for="(dateItem, index) of currentDate"
                      :key="index"
                    >
                      <div class="date">
                        <div>{{ formatDate(dateItem) }}</div>
                        <div class="detail">
                          {{ getWeekday(dateItem) }}
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul class="list-content">
                    <li
                      v-for="(timeItem, timeIndex) of timeRange"
                      :key="timeIndex"
                    >
                      <ul class="date-content-list">
                        <li
                          class="content-item"
                          v-for="(dateItem, dateIndex) of currentDate"
                          :key="dateIndex"
                        >
                          <div
                            :class="[
                              'rest-count-item',
                              restCount(itemData(dateItem, timeItem.time_id)) <= 0
                                ? 'disabled'
                                : '',
                            ]"
                            @click="
                              addAppointment(
                                itemData(dateItem, timeItem.time_id)
                              )
                            "
                          >
                            {{ $t("appointment.restCount")
                            }}{{
                              restCount(itemData(dateItem, timeItem.time_id))
                            }}
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </mm-carousel-item>
        </mm-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ApplyAppointmentModal from "./apply-appointment-modal.vue";
import AppointmentDemandForm from "./appointment-demand-form.vue";
import createPortal from "amumu-ui/src/factory/create-portal";
import moment from "moment";
import AppointmentApi from "@api/appointment";

export default {
  data() {
    return {
      pageShow: {
        form: false,
        appointment: false
      },
      timeRange: [
        {
          time: "10: 00-11: 30",
          time_id: 1,
        },
        {
          time: "14: 00-15: 30",
          time_id: 2,
        },
        {
          time: "16: 00-17: 30",
          time_id: 3,
        },
      ],
      currentPage: 1,
      date: [],
      appointmentList: [],
      pageCount: 0,
      company: "",
      carouselHeight: 300,
    };
  },
  computed: {
    ...mapState("appointment", {
      appointmentInfo: (state) => state.appointmentInfo,
    }),
    ...mapGetters("appointment", ["appointmentStatus"]),
    currentDate() {
      return this.date.filter(
        (item, index) =>
          index >= this.currentPage * 5 - 5 && index < this.currentPage * 5
      );
    },
    list() {
      const listObject = {};
      this.appointmentList.forEach((item) => {
        listObject[`${item.date}-${item.start_time}~${item.end_time}`] = item;
      });
      return listObject;
    },
  },
  components: {
    AppointmentDemandForm,
  },
  watch: {
    appointmentInfo() {
      this.initAppointmentData();
    },
  },
  created() {
    this.initStatus()
  },
  methods: {
    ...mapActions("appointment", ["fetchAppointmentList"]),
    pageShowFn(form, appointment) {
      this.pageShow = {
        form,
        appointment
      }
    },
    initStatus() {
      AppointmentApi.fetchAppointmentStatus().then(data => {
        if (String(data['impl-client-status']) === '1') {
          this.pageShowFn(false, true)
        } else {
          this.pageShowFn(true, false)
        }
      })
    },
    initAppointmentData() {
      this.appointmentList = this.appointmentInfo.apply_list;
      this.date = [...new Set(this.appointmentList.map((item) => item.date))];
      this.pageCount = Math.ceil(this.date.length / 5);
      this.company = this.appointmentInfo.client_info.full_name;
      this.timeRange = this.appointmentInfo.time_list.map((item) => {
        item.time_id = item.implementation_time;
        return item;
      });
      this.carouselHeight =
        this.timeRange.length <= 3
          ? this.carouselHeight
          : (this.timeRange.length + 1) * 68;
    },
    itemData(data, timeIndex) {
      return this.list[`${data}-${timeIndex}`];
    },
    restCount(info) {
      return info ? Number(info.remaining_appointment_num) : 0;
    },
    formatDate(date) {
      return moment(new Date(date)).format("MM月DD日");
    },
    getWeekday(date) {
      return moment(new Date(date)).format("ddd");
    },
    changeList(val) {
      this.currentPage = val + 1;
    },
    addAppointment(info = {}) {
      if (!info.remaining_appointment_num) {
        return;
      }
      createPortal({
        context: this,
        component: ApplyAppointmentModal,
        props: {
          visible: true,
          info,
          company: this.company,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.appointment-box {
  top: 0 !important;
  left: 50% !important;
  transform: translate(-50%, 0) !important;
}
.appointment-list {
  color: #2a2a2a;
  text-align: center;
  padding: 60px 60px 80px;
  .mm-carousel {
    .mm-carousel-arrow.mm-carousel-arrow-always {
      .carousel-arrow-right,
      .carousel-arrow-left {
        width: 30px;
        height: 30px;
        padding-top: 3px;
        background: #f5f5f5;
        svg {
          fill: #b6b6b6;
        }
      }
    }
  }
  .left-active
    .mm-carousel-arrow.mm-carousel-arrow-always
    .carousel-arrow-left
    svg {
    fill: #0064ff;
  }
  .right-active
    .mm-carousel-arrow.mm-carousel-arrow-always
    .carousel-arrow-right
    svg {
    fill: #0064ff;
  }

  .list-title {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .list-tip {
    margin-bottom: 57px;
  }
  .list-table {
    .list-item {
      width: 100%;
      padding: 0 70px;
      display: flex;
      box-sizing: border-box;
      .list-left {
        width: 124px;
        display: flex;
        flex-direction: column;
        margin-top: 68px;
        li {
          padding-bottom: 6px;
          &:last-child {
            padding-bottom: 0;
          }
        }
        .time {
          height: 62px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 12px;
          color: #2a2a2a;
          font-weight: 500;
        }
      }
      .list-right {
        width: 650px;
        .list-header {
          display: flex;
          height: 62px;
          margin-left: 6px;
          li {
            flex: 0.2;
          }
          .date {
            font-size: 14px;
            color: #2a2a2a;
            font-weight: 500;
          }
        }
        .list-content {
          width: 100%;
          height: 204px;
          .date-content-list {
            width: 100%;
            display: flex;
          }
          .content-item {
            margin: 6px 0 0 6px;
            width: 124px;
            height: 62px;
          }
          .rest-count-item {
            width: 100%;
            height: 100%;
            background: #e7f0ff;
            text-align: center;
            color: #909090;
            font-size: 12px;
            line-height: 62px;
            cursor: pointer;
            border-radius: 4px;
            &:hover {
              background: #0064ff;
              color: #fff;
            }
          }
          .disabled {
            background: #f5f5f5;
            pointer-events: none;
          }
        }
      }
      .list-index {
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f5f5;
          .detail {
            font-size: 12px;
            color: #909090;
          }
        }
      }
    }
  }
}
</style>
